import { Trans, useTranslation } from 'react-i18next';
import * as z from 'zod';
import { ProgressLayout } from '../../../components/layouts/progress-layout';
import { PatchInviteForm } from '../../../components/patch-invite-form';
import { Input } from '../../../components/ui/input';

const schema = z.object({
  weight: z.coerce.number().min(1),
  height: z.coerce.number().min(1),
});

function extractDefaults({ healthQuestionWeightHeight }) {
  return {
    weight: healthQuestionWeightHeight?.weight ?? '',
    height: healthQuestionWeightHeight?.height ?? '',
  };
}

function transformValues(values) {
  return { healthQuestionWeightHeight: values };
}

export function HealthQuestionsWeightHeight(props) {
  const { t } = useTranslation(['page.health-questions', 'common']);

  return (
    <PatchInviteForm
      extractDefaults={extractDefaults}
      transformValues={transformValues}
      schema={schema}
      nextPath={props.next.path}
    >
      <ProgressLayout {...props}>
        <Trans
          t={t}
          i18nKey="questions.weightHeight.title"
          components={{ h3: <h3 className="title" />, p: <p /> }}
        />
        <div className="flex items-start flex-nowrap gap-5 sm:gap-8.75">
          <Input
            inputMode="numeric"
            name="weight"
            label={t('questions.weightHeight.weight')}
            suffix={t('questions.weightHeight.kg')}
            size="lg"
          />
          <Input
            inputMode="numeric"
            name="height"
            label={t('questions.weightHeight.height')}
            suffix={t('questions.weightHeight.cm')}
            size="lg"
          />
        </div>
      </ProgressLayout>
    </PatchInviteForm>
  );
}
